// Adding this for cases where we need to pass scss variable values into components
// this is the source of truth, so we don't need to pass multiple strings

const $black85 = "#262626";

export default { $black85 };
